import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Ant - Tree
import Statistic from 'ant-design-vue/lib/statistic';  // for js
import Tree from 'ant-design-vue/lib/tree';  // for js
import Input from 'ant-design-vue/lib/input';  // for js
import Drawer from 'ant-design-vue/lib/drawer';  // for js
import CheckBox from 'ant-design-vue/lib/checkbox';  // for js
import Switch from 'ant-design-vue/lib/switch';  // for js
import Tabs from 'ant-design-vue/lib/tabs';  // for js
import Select from 'ant-design-vue/lib/select';  // for js
import Popconfirm from 'ant-design-vue/lib/popconfirm';  // for js
import DatePicker from 'ant-design-vue/lib/date-picker';  // for js
import TimePicker from 'ant-design-vue/lib/time-picker';  // for js
import Steps from 'ant-design-vue/lib/steps';
import Upload from 'ant-design-vue/lib/upload';
import Modal from 'ant-design-vue/lib/modal';
import Collapse from 'ant-design-vue/lib/collapse';
import Radio from 'ant-design-vue/lib/radio';
import List from 'ant-design-vue/lib/list';
import Dropdown from 'ant-design-vue/lib/dropdown';
import Menu from 'ant-design-vue/lib/menu';
import Slider from 'ant-design-vue/lib/slider';
import Spin from 'ant-design-vue/lib/spin';
import Cascader from 'ant-design-vue/lib/cascader';
import Table from 'ant-design-vue/lib/table';
import InputNumber from 'ant-design-vue/lib/input-number';
import Tag from 'ant-design-vue/lib/tag';
import notification from 'ant-design-vue/lib/notification';
import message from 'ant-design-vue/lib/message';
import Card from 'ant-design-vue/lib/card';
import AutoComplete from 'ant-design-vue/lib/auto-complete';
import Button from 'ant-design-vue/lib/button';
import Icon from 'ant-design-vue/lib/icon';
import Empty from 'ant-design-vue/lib/empty';
import Pagination from 'ant-design-vue/lib/pagination';
import Rate from 'ant-design-vue/lib/rate';
import Avatar from 'ant-design-vue/lib/avatar';
import Popover from 'ant-design-vue/lib/popover';
import Badge from 'ant-design-vue/lib/badge';
import Tooltip from 'ant-design-vue/lib/tooltip';
import Form from 'ant-design-vue/lib/form';
import Progress from 'ant-design-vue/lib/progress';

import 'ant-design-vue/lib/tree/style/css';  // for css
import 'ant-design-vue/lib/input/style/css';  // for css
import 'ant-design-vue/lib/drawer/style/css';  // for css
import 'ant-design-vue/lib/checkbox/style/css';  // for css
import 'ant-design-vue/lib/switch/style/css';  // for css
import 'ant-design-vue/lib/tabs/style/css';  // for css
import 'ant-design-vue/lib/select/style/css';  // for css
import 'ant-design-vue/lib/popconfirm/style/css';  // for css
import 'ant-design-vue/lib/date-picker/style/css';  // for css
import 'ant-design-vue/lib/time-picker/style/css';  // for css
import 'ant-design-vue/lib/steps/style/css';  // for css
import 'ant-design-vue/lib/upload/style/css';
import 'ant-design-vue/lib/modal/style/css';
import 'ant-design-vue/lib/collapse/style/css';
import 'ant-design-vue/lib/radio/style/css';
import 'ant-design-vue/lib/list/style/css';
import 'ant-design-vue/lib/dropdown/style/css';
import 'ant-design-vue/lib/menu/style/css';
import 'ant-design-vue/lib/slider/style/css';
import 'ant-design-vue/lib/spin/style/css';
import 'ant-design-vue/lib/cascader/style/css';
import 'ant-design-vue/lib/table/style/css';
import 'ant-design-vue/lib/input-number/style/css';
import 'ant-design-vue/lib/tag/style/css';
import 'ant-design-vue/lib/notification/style/css';
import 'ant-design-vue/lib/message/style/css';
import 'ant-design-vue/lib/card/style/css';
import 'ant-design-vue/lib/auto-complete/style/css';
import 'ant-design-vue/lib/button/style/css';
import 'ant-design-vue/lib/icon/style/css';
import 'ant-design-vue/lib/empty/style/css';
import 'ant-design-vue/lib/pagination/style/css';
import 'ant-design-vue/lib/rate/style/css';
import 'ant-design-vue/lib/avatar/style/css';
import 'ant-design-vue/lib/popover/style/css';
import 'ant-design-vue/lib/statistic/style/css';
import 'ant-design-vue/lib/badge/style/css';
import 'ant-design-vue/lib/tooltip/style/css';
import 'ant-design-vue/lib/form/style/css';

Vue.use(Tree)
Vue.use(Input)
Vue.use(Drawer)
Vue.use(CheckBox)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(Select)
Vue.use(Popconfirm)
Vue.use(TimePicker)
Vue.use(DatePicker)
Vue.use(Steps)
Vue.use(Upload)
Vue.use(Modal)
Vue.use(Collapse)
Vue.use(Radio)
Vue.use(List)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Slider)
Vue.use(Spin)
Vue.use(Cascader)
Vue.use(Table)
Vue.use(InputNumber)
Vue.use(Tag)
Vue.use(Card)
Vue.use(AutoComplete)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Empty)
Vue.use(Pagination)
Vue.use(Rate)
Vue.use(Avatar)
Vue.use(Popover)
Vue.use(Statistic)
Vue.use(Badge)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(Progress)

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;


// Google Places API
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyButngNYEXbOOey2UGwvNlFO_S8qzdAhaM',
    libraries: 'geometry', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  // installComponents: true
})
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-marker', VueGoogleMaps.Marker);

// theme
import ArgonDashboard from './plugins/argon-dashboard'
Vue.config.productionTip = false
Vue.use(ArgonDashboard)


// reusable for dynamic form
const PosMainMenu = () => import("./views/PosMainMenu.vue");
Vue.component('PosMainMenu', PosMainMenu);

const PosFunctionKeys = () => import("./views/PosFunctionKeys.vue");
Vue.component('PosFunctionKeys', PosFunctionKeys);

const BrandForm = () => import("./views/BrandForm.vue");
Vue.component('BrandForm', BrandForm);

const ProductSeries = () => import("./views/ProductSeries.vue");
Vue.component('ProductSeries', ProductSeries);

const ProductGroup = () => import("./views/ProductGroup.vue");
Vue.component('ProductGroup', ProductGroup);

const ProductsUserField = () => import("./views/ProductUsersField.vue");
Vue.component('ProductsUserField', ProductsUserField);

const ReceiptLogo = () => import("./views/ReceiptLogo.vue");
Vue.component('ReceiptLogo', ReceiptLogo);

const SeniorCitizenPwdForm = () => import("./views/SeniorCitizenPwdForm.vue");
Vue.component('SeniorCitizenPwdForm', SeniorCitizenPwdForm);

//vuex
import store from './store/store'

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

// import jsPDF from 'jspdf'
// Vue.use(jsPDF)

//vueTable
import VueTable from 'vuetable-2'
Vue.use(VueTable)

//VueTabulator
import VueTabulator from 'vue-tabulator';
Vue.use(VueTabulator);

//lodash
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
require("lodash-inflection");
// name is optional
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

// Encryption
import secureStorage from './controllers/secureStorage.js'

//Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// import { setEnabledCategories } from './utilities.js'
// setEnabledCategories();

// router
import router from './router'
// eslint-disable-next-line

new Vue({
  secureStorage,
  store,
  router,
  render: h => h(App)
}).$mount('#app')

//cookie
import cookieconsent from 'vue-cookieconsent-component'
Vue.component('cookie-consent', cookieconsent)

//google
import { LoaderPlugin } from 'vue-google-login'
Vue.use(LoaderPlugin, {
  client_id: "609424787778-eh50vspe8o92o306gooto8sfjgv1i52g.apps.googleusercontent.com"
});

//facebook
import VFacebookLogin from 'vue-facebook-login-component'

require('es6-shim');
import '../src/directives/websdk.client.bundle.min.js'  

//lazy load
import { VLazyImagePlugin } from 'v-lazy-image'
Vue.use(VLazyImagePlugin);

//HTML Editor

import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble themeimport { ResponsiveLayoutModule } from 'tabulator-tables'

var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);